import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 15px 0px 30px;
  gap: 16px;
`

export const FilterContainer = styled.div`
  display: flex;
  gap: 10px;
  align-self: center;
  width: ${({ wide }) => wide ? 360 : 220}px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
  margin: 0px;
`

// Número inteiro no card (atendimentos): o `CardMoney` da DRE fixa o prefixo "R$".
export const CardCount = styled.span`
  color: #252525;
  font-size: 20px;
  font-weight: 600;
`

// Marca a linha da profissional que ficou fora da projeção. Vai junto do nome, numa célula que
// corta o que passa da largura, então é um caractere só — a explicação fica na legenda da tabela.
export const Marker = styled.span`
  color: #FF9500;
  font-weight: 600;
  margin-left: 4px;
`

export const Legend = styled.p`
  color: #777777;
  font-size: 12px;
  margin: 0px;
`

/*
  A meta, embaixo do realizado, dentro da célula de valor. É um bloco próprio (e não um
  `HintText as='span'` depois de um `<br/>`) para que as reticências sejam dela, e não da
  célula inteira: assim o realizado nunca some junto quando a meta é que não coube.

  Menor e cinza de propósito — a linha que o salão lê primeiro é o realizado, acima.
*/
export const GoalText = styled.span`
  display: block;
  margin-top: 2px;
  color: #777777;
  font-size: 11px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
